import { CustomerSite } from "@hydrologiq/gql-experience/graphql"
import { SkeletonText, SimpleGrid, GridItem } from "@chakra-ui/react"
import { Field } from "@hydrologiq/shared/chakra/Field"
import { Editable } from "@hydrologiq/shared/chakra/Editable"
import { useRenameSite } from "../../hooks/useRenameCustomer"

const CustomerSiteInformation = ({ site }: { site?: CustomerSite | null }) => {
  const { renameSite, renaming: loading } = useRenameSite(site)

  const handleNameUpdate = async (newName: string) => {
    await renameSite(newName)
  }

  return (
    <SimpleGrid columns={{ base: 2 }} gap={5}>
      <GridItem height={"100%"}>
        <Field
          label="Name:"
          flexDirection={"row"}
          height={"40px"}
          width={"100%"}
          maxWidth={"500px"}
          alignItems={"start"}
          justifyContent={"space-between"}
          alignment="center"
          labelHeight="100%"
        >
          {site?.name ? (
            <Editable variant="hydrologiq" defaultValue={site.name} onValueSave={handleNameUpdate} disabled={loading} />
          ) : (
            <SkeletonText noOfLines={1} />
          )}
        </Field>
      </GridItem>
    </SimpleGrid>
  )
}

export default CustomerSiteInformation
